import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AfterViewInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { Workflow } from "../core/model/workflow";
import { WorkflowService } from "../core/service/workflow.service";
import { TypeCreditService } from "../core/service/type-credit.service";
import { ProduitService } from "../core/service/produit.service";
import { DocumentService } from "../core/service/document.service";
import { DocumentSelectedDTO } from "../core/model/document-selected-dto";
import { TypeCredit } from "../core/model/type-credit";
import { Produit } from "../core/model/produit";
import { EditCheckListComponent } from "./edit-check-list/edit-check-list.component";
import { AddCheckListComponent } from "./add-check-list/add-check-list.component";
import { AssocierDocumentAuProduit } from "../core/model/associer-document-au-produit";

@Component({
  selector: "app-check-list-document",
  templateUrl: "./check-list-document.component.html",
  styleUrls: ["./check-list-document.component.scss"],
})
export class CheckListDocumentComponent implements OnInit {
  produitId: string;
  filterValue: String = "_";

  workflows: Workflow[];
  typeCredits: TypeCredit[];
  produits: Produit[];
  documents: DocumentSelectedDTO[];

  displayedColumns: string[] = [
    "id",
    "label",
    "code",
    "obligatoire",
    "actions",
  ];

  resultsLength = 0;
  isLoadingResults = false;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _workflowService: WorkflowService,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private _documentService: DocumentService
  ) {}

  ngOnInit() {
    this.getAllWorkflows();
  }

  getAllWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListTypeCredit(workflowcode) {
    this._typeCreditService.getListTypeCreditByWorkflow(workflowcode).subscribe(
      (data) => {
        this.typeCredits = data.sort((a, b) => (a.label > b.label ? 1 : -1));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListproduitByTypeCredit(typeCreditId) {
    this._produitService.getListproduitByTypeCredit(typeCreditId).subscribe(
      (data) => {
        this.produits = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getAllDocuments(produitId: string, filter: String, pageIndex: number): void {
    this.produitId = produitId;
    this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = pageIndex)
    );

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this._documentService.findSelectedDocumentPageable(
            filter,
            produitId,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map((data) => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe((data) => (this.documents = data));
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.getAllDocuments(this.produitId, this.filterValue, 0);
  }

  edit(documentId): void {
    const modalRef = this.modalService.open(EditCheckListComponent, {
      centered: true,
    });
    modalRef.componentInstance.documentId = documentId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getAllDocuments(this.produitId, this.filterValue, 0);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddCheckListComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getAllDocuments(this.produitId, this.filterValue, 0);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  changeAfterChecked(values: any, documentId) {
    var input = new AssocierDocumentAuProduit();
    input.documentId = documentId;
    input.produitId = this.produitId;
    input.selected = values.checked;
    this.associer(input);
  }

  associer(associerDocumentAuProduit: AssocierDocumentAuProduit) {
    this._documentService.associer(associerDocumentAuProduit).subscribe(
      (data) => {
        this.getAllDocuments(this.produitId, this.filterValue, 0);
      },
      (error) => {
        console.log(error);
      },
      () => {}
    );
  }
}
